import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { BulkUpload } from '@app/core/models/bulk-upload.model';

import * as XLSX from 'xlsx';
import { BulkOrderService } from '@app/core/services';
import { AlertDialogComponent } from '@app/shared/components';
@Component({
  selector: 'ecp-order-upload',
  templateUrl: './order-upload.component.html',
  styleUrls: ['./order-upload.component.scss'],
})
export class OrderUploadComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private bulkOrder: BulkOrderService,
  ) {}
  fileUploadGroup: FormGroup;
  @Output() orderUploadData = new EventEmitter<any>();
  bulkData: BulkUpload = {
    useType: '',
    LocationId: '',
    fDAccountNumber: '',
    upc: '',
    //lab: '',
    orderType: '',
    patientFirstName: '',
    patientLastName: '',
    rxOrderId: '',
    pONumber: '',
    quantity: 0,
  };
  file: AbstractControl;
  selectedFile: File;
  loading: boolean = false;
  private arrayBuffer;
  filHeader: any = [
    'useType',
    'LocationId',
    'fDAccountNumber',
    'upc',
    'orderType',
    'patientFirstName',
    'patientLastName',
    'rxOrderId',
    'pONumber',
    'quantity',
  ];
  ngOnInit(): void {
    this.file = this.fb.control('', [Validators.required]);
  }

  onFileChange($event) {
    this.selectedFile = $event.target.files[0];
  }
  cancelUpload() {
    this.file.reset();
  }

  submitForValidation() {
    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'File Upload Confirmation',
          content: `Are you sure you would like to upload ${this.selectedFile.name} and submit the file for validation?`,
          cancelBtnText: 'Cancel',
          confirmBtnText: 'Confirm',
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe(async (resp) => {
        this.loading = true;
        if (resp) {
          this.parseUploadFile();
        } else {
          this.loading = false;
          this.file.reset();
        }
      });
  }
  parseUploadFile() {
    const fileName = this.selectedFile.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();

    const fileReader = new FileReader();

    if (fileExtension === 'csv') {
      fileReader.onload = (e) => {
        const contents = e.target.result;
        var payLoadData = this.parseCSV(contents);
        this.validateFile(payLoadData);
      };
      fileReader.readAsText(this.selectedFile);
    } else if (fileExtension === 'xlsx') {
      fileReader.onload = () => {
        this.arrayBuffer = fileReader.result;
        var payLoadData = this.parseXLSX(this.arrayBuffer);
        this.validateFile(payLoadData);
      };
      fileReader.readAsArrayBuffer(this.selectedFile);
    } else {
    }
  }
  parseCSV(csvString: any) {
    const lines = csvString.split('\n');
    const objs = [];
    for (let i = 1; i < lines.length; i++) {
      const data = lines[i].split(',');
      // Assign predetermined keys to data values
      if (data.length > 11) {
        var order = {
          useType: data[1].trim(),
          locationId: data[2].trim(),
          fdAccountNumber: data[3].trim(),
          upc: data[4].trim()?.replace(/'/g, ''),
          //  lab: data[5].trim(),
          orderType: data[6].trim(),
          patientFirstName: data[7].trim(),
          patientLastName: data[8].trim(),
          rxOrderId: data[9].trim(),
          pONumber: data[10].trim(),
          quantity: data[11].trim(),
        };
        objs.push(order);
      }
    }
    return objs;
  }
  checkFileFormat(pl: BulkUpload) {
    return this.filHeader.every((key: any) => key in pl);
  }
  validateFile(payload: BulkUpload[]) {
    const fileLength = payload.length;
    const isFileValid = fileLength > 0 ? this.checkFileFormat(payload[0]) : false;
    if (isFileValid && fileLength > 0) {
      this.bulkOrder.validateOrders(payload).subscribe(
        (e) => {
          var hasError = e.filter((order) => order.uploadStatus.toLowerCase() === 'failed');
          const orderUploadResponse = {
            uploadDate: new Date(),
            fileName: this.selectedFile.name,
            fileSize: e.length,
            uploadReceived: hasError.length >= 1 ? false : true,
            uploadHasError: hasError.length >= 1 ? true : false,
            data: e,
          };
          this.loading = false;
          this.orderUploadData.emit(orderUploadResponse);
        },
        (err) => {
          this.fileUploadError();
          this.loading = false;
          console.log(err);
        },
      );
    } else {
      this.loading = false;
      this.fileUploadError(fileLength > 0);
    }
  }
  fileUploadError(hasRow:boolean = true) {
    const errorMessage = !hasRow ? `No Record(s) Found in File`: `Unsupported File Format`;
    this.dialog.open(AlertDialogComponent, {
      width: '364px',
      maxWidth: '90vw',
      data: {
        title: 'Bulk Order',
        content: errorMessage,
        confirmBtnText: 'Confirm',
      },
      disableClose: true,
    });
  }
  parseXLSX(xlsxArray: any) {
    const data = new Uint8Array(xlsxArray);
    const arr = [];
    for (let i = 0; i !== data.length; ++i) arr[i] = String.fromCharCode(data[i]);
    const bstr = arr.join('');
    const workbook = XLSX.read(bstr, { type: 'binary' });
    const first_sheet_name = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[first_sheet_name];
    const rows = XLSX.utils.sheet_to_json(worksheet, { raw: false, blankrows: false });
    //map to object
    var mappedData = rows.map((e: any) => {
      return {
        useType: e['Use Type'] || e['UseType'] || e['useType'],
        LocationId: e['Location ID'] || e['LocationID'] || e['locationId'],
        fDAccountNumber: e['FD Account #'] || e['fdAccountNumber'] || e['Account Number'] || e['accountNumber'],
        upc: e['UPC']?.replace(/'/g, '') || e['upc']?.replace(/'/g, ''),
        //lab: e['Lab'] || e['lab'],
        orderType: e['Order Type'] || e['orderType'],
        patientFirstName: e['Patient First Name'] || e['patientFirstName'],
        patientLastName: e['Patient Last Name'] || e['patientLastName'],
        rxOrderId: e['Rx Order ID'] || e['rxOrderId'],
        pONumber: e['PO Number'] || e['poNumber'],
        quantity: e['Quantity'] || e['quantity'],
        // Add more fields as needed.
      };
    });
    return mappedData;
  }
  private getForm() {
    return this.fb.group({
      file: [null],
    });
  }
}
